export default __webpack_public_path__ + "static/tooltip-contents-dont-dark-27ffb0c8bac6dd4984ac0432e6d6bc46e69ed1ada55e9da4029f26f679c0b6a4.png";